export default "__VITE_ASSET__udv_JESr__"